// extracted by mini-css-extract-plugin
export default {"wrapper":"ContactItem_wrapper__hoj5-","link":"ContactItem_link__8mH8L","icon":"ContactItem_icon__PLw5d"};